module.exports = __webpack_public_path__ + "img/3.fb122344.png";